// Pills

window.SiteReady(($) => {
  console.log('Init: Pills');

  //

  function updatePill(wrapper, targetEl = null) {
    const $wrapper = $(wrapper);
    const $pill = $wrapper.find('.js-pills_indicator');
    const activeEl = targetEl || $wrapper.find('.js-pills_item.active')[0];

    if (activeEl && $pill.length) {
      $pill.css({
        width: activeEl.offsetWidth + 'px',
        height: activeEl.offsetHeight + 'px',
        left: activeEl.offsetLeft + 'px',
        top: activeEl.offsetTop + 'px'
      });
    }
  }

  function refreshAllPills() {
    requestAnimationFrame(() => {
      $('.js-pills_wrapper').each(function() {
        updatePill(this);
      });
    });
  }

  //

  $(document).on('click.pills', '.js-pills_item', function() {
    const $wrapper = $(this).closest('.js-pills_wrapper');

    if ($wrapper.length) {
      updatePill($wrapper[0], this);
    }
  });

  //

  $(window).on('resize.pills', refreshAllPills);

  setTimeout(refreshAllPills, 50);

  window.refreshPills = refreshAllPills;
});
